const ImageAlignFull = (domEl) => {

	const updateDimensions = () => {
		const rect = domEl.getBoundingClientRect();
		const width = window.innerWidth - rect.left;
		domEl.style.width = `${width}px`;

		const minWidth = 960;
		const maxWidth = 1075;
		const maxPadding = (100 - ((880 / 995) * 100)) / 2;

		let paddingLeft;

		if (window.innerWidth < minWidth) {
			paddingLeft = 0;
		}
		else if (window.innerWidth >= maxWidth) {
			paddingLeft = maxPadding;
		}
		else {
			const ratio = (window.innerWidth - minWidth) / (maxWidth - minWidth);
			paddingLeft = ratio * maxPadding;
		}

		domEl.style.paddingLeft = `${paddingLeft}%`;
	};

	// Initial dimension update
	updateDimensions();

	// Add event listener for window resize
	window.addEventListener('resize', updateDimensions);
};

export default ImageAlignFull;
